module.exports = __webpack_public_path__ + "static/media/user-attendance.39efec7e.png";